import { Box, Spinner } from '@chakra-ui/react'
type CenteredSpinnerProps = {
  height?: string | number
  width?: string | number
}
const CenteredSpinner = ({ width = '100%', height = '100%' }: CenteredSpinnerProps) => (
  <Box
    alignItems="center"
    display="flex"
    height={height}
    justifyContent="center"
    width={width}
  >
    <Spinner />
  </Box>
)

export default CenteredSpinner
